import { GET_DRIVER_DISPATCH_BETWEEN,
    GET_DRIVER_DISPATCH_BETWEEN_SUCCESS,
    GET_DRIVER_DISPATCH_BETWEEN_FAIL,
    GET_DRIVER_DISPATCH_BY_ID,
    GET_DRIVER_DISPATCH_BY_ID_SUCCESS,
    GET_DRIVER_DISPATCH_BY_ID_FAIL,
    GET_LETIAN_STAFF,
    GET_LETIAN_STAFF_SUCCESS,
    GET_LETIAN_STAFF_FAIL,
    QUICK_TRANSFER_ORDERS,
    QUICK_TRANSFER_ORDERS_SUCCESS,
    QUICK_TRANSFER_ORDERS_FAIL,
    GET_DRIVER_DROPOFF_HISTORY,
    GET_DRIVER_DROPOFF_HISTORY_SUCCESS,
    GET_DRIVER_DROPOFF_HISTORY_FAIL,
    GET_DISPATCH_LIST_HISTORY,
    GET_DISPATCH_LIST_HISTORY_SUCCESS,
    GET_DISPATCH_LIST_HISTORY_FAIL,
    GET_ORDERS_BY_DRIVER_CRITERIA,
    GET_ORDERS_BY_DRIVER_CRITERIA_SUCCESS,
    GET_ORDERS_BY_DRIVER_CRITERIA_FAIL,
    GET_SCAN_BATCH_REPORTS,
    GET_SCAN_BATCH_REPORTS_SUCCESS,
    GET_SCAN_BATCH_REPORTS_FAIL,
    HANDLE_DRIVER_ID_DISPATCH
} from '../actions/types';

const initialState = {
    getDriverDispatchBetweenLoading: false,
    getDriverDispatchBetween: [],
    getDriverDispatchBetweenError: false,
    getDriverDispatchByIdLoading: false,
    getDriverDispatchById: [],
    getDriverDispatchByIdError: false,
    getLetianStaffLoading: false,
    getLetianStaff: [],
    getLetianStaffError: false,
    quickTransferOrdersLoading: false,
    quickTransferOrders: [],
    quickTransferOrdersError: false,
    dropoffListLoading: false,
    dropoffList: [],
    dropoffListError: false,
    dispatchListLoading: false,
    dispatchList: [],
    dispatchListError: false,
    dispatchListByDispatchNoLoading: false,
    dispatchListByDispatchNo: [],
    dispatchListByDispatchNoError: false,
    ordersLoading: false,
    orders: [],
    ordersError: false,
    dispatchListPeriod: [],
    dispatchListPeriodLoading: false,
    dispatchListPeriodError: false,
    driverId: null
}

export default function ddReducer(state = initialState, action){
    switch(action.type){
        case HANDLE_DRIVER_ID_DISPATCH:
            return {
                ...state,
                driverId: action.payload,
            }
        case GET_SCAN_BATCH_REPORTS:
            return {
                ...state,
                dispatchListPeriodLoading: true,
            }
        case GET_SCAN_BATCH_REPORTS_SUCCESS:
            return {
                ...state,
                dispatchListPeriod: action.payload,
                dispatchListPeriodLoading: false
            }
        case GET_SCAN_BATCH_REPORTS_FAIL:
            return {
                ...state,
                dispatchListPeriodLoading: false,
                dispatchListPeriodError: action.payload
            }
        case GET_ORDERS_BY_DRIVER_CRITERIA:
            return {
                ...state,
                ordersLoading: true,
            }
        case GET_ORDERS_BY_DRIVER_CRITERIA_SUCCESS:
            return {
                ...state,
                orders: action.payload,
                ordersLoading: false
            }
        case GET_ORDERS_BY_DRIVER_CRITERIA_FAIL:
            return {
                ...state,
                ordersLoading: false,
                ordersError: action.payload
            }
        case GET_DISPATCH_LIST_HISTORY:
            return {
                ...state,
                dispatchListLoading: true,
            }
        case GET_DISPATCH_LIST_HISTORY_SUCCESS:
            return {
                ...state,
                dispatchList: action.payload,
                dispatchListLoading: false
            }
        case GET_DISPATCH_LIST_HISTORY_FAIL:
            return {
                ...state,
                dispatchListLoading: false,
                dispatchListError: action.payload
            }
        case GET_DRIVER_DROPOFF_HISTORY:
            return {
                ...state,
                dropoffListLoading: true,
            }
        case GET_DRIVER_DROPOFF_HISTORY_SUCCESS:
            return {
                ...state,
                dropoffList: action.payload,
                dropoffListLoading: false
            }
        case GET_DRIVER_DROPOFF_HISTORY_FAIL:
            return {
                ...state,
                dropoffListLoading: false,
                dropoffListError: action.payload
            }
        case GET_DRIVER_DISPATCH_BETWEEN:
            return {
                ...state,
                getDriverDispatchBetweenLoading: true,
            }
        case GET_DRIVER_DISPATCH_BETWEEN_SUCCESS:
            return {
                ...state,
                getDriverDispatchBetween: action.payload,
                getDriverDispatchBetweenLoading: false
            }
        case GET_DRIVER_DISPATCH_BETWEEN_FAIL:
            return {
                ...state,
                getDriverDispatchBetweenLoading: false,
                getDriverDispatchBetweenError: action.payload
            }
        case GET_DRIVER_DISPATCH_BY_ID:
            return {
                ...state,
                getDriverDispatchByIdLoading: true,
            }
        case GET_DRIVER_DISPATCH_BY_ID_SUCCESS:
            return {
                ...state,
                getDriverDispatchById: action.payload,
                getDriverDispatchByIdLoading: false
            }
        case GET_DRIVER_DISPATCH_BY_ID_FAIL:
            return {
                ...state,
                getDriverDispatchByIdLoading: false,
                getDriverDispatchByIdError: action.payload
            }
        case GET_LETIAN_STAFF:
            return {
                ...state,
                getLetianStaffLoading: true,
            }
        case GET_LETIAN_STAFF_SUCCESS:
            return {
                ...state,
                getLetianStaff: action.payload,
                getLetianStaffLoading: false
            }
        case GET_LETIAN_STAFF_FAIL:
            return {
                ...state,
                getLetianStaffLoading: false,
                getLetianStaffError: action.payload
            }
        case QUICK_TRANSFER_ORDERS:
            return {
                ...state,
                quickTransferOrdersLoading: true,
            }
        case QUICK_TRANSFER_ORDERS_SUCCESS:
            return {
                ...state,
                quickTransferOrders: action.payload,
                quickTransferOrdersLoading: false
            }
        case QUICK_TRANSFER_ORDERS_FAIL:
            return {
                ...state,
                quickTransferOrdersLoading: false,
                quickTransferOrdersError: action.payload
            }
        default:
            return state;
    }
}